// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bookmarkletButton":"bookmarklet-button__bookmarkletButton__6r66z"};